export default "__VITE_ASSET__D3Svy7za__"